import React from "react";
import { Redirect } from 'react-router-dom';
import Dialog from "../Dialog";
import MUITypography from "@mui/material/Typography";
import MUITable from '@mui/material/Table';
import MUITableBody from '@mui/material/TableBody';
import MUITableCell from '@mui/material/TableCell';
import MUITableContainer from '@mui/material/TableContainer';
import MUITableHead from '@mui/material/TableHead';
import MUITableRow from '@mui/material/TableRow';
import MUIPaper from "@mui/material/Paper";
import MUIGrid from "@mui/material/Grid";
import MUIBox from "@mui/material/Box";
import MUITextField from "@mui/material/TextField";
import MUIInputAdornment from "@mui/material/InputAdornment";
import MUISearchIcon from "@mui/icons-material/Search";
import MUILoadingButton from "@mui/lab/LoadingButton";
import MUIIconButton from "@mui/material/IconButton";
import MUIOpenInNew from "@mui/icons-material/OpenInNew";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import MUIPersonAddIcon from "@mui/icons-material/PersonAdd";
import MUIArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MUIChildCareIcon from '@mui/icons-material/ChildCare';
import MUIBlueColor from "@mui/material/colors/blue";
import { buildScrollbarSxOverrides } from "../../Theme/ThemeProvider";
import MUITooltip from "@mui/material/Tooltip";
import MUIHelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Menu from "../Menu";
import EmptyState from "../EmptyState";
import Progress from "../Progress";
import api from "../../Seating/Security/api";
import moment from "moment";

export default class DialogOmniSearch extends Dialog {
    constructor(props) {
        super(props);

        this.state = {
            rows: props.rows,
            loading: props.loading || false,
            searchQuery: props.searchQuery || "",
            open: props.open || false,
        };
    }

    componentDidMount() {
        if (this.state.open) {
            this.performOmniSearch();
        }
    }

    /**
     * Render header title of dialog
     */
    renderHeader() {
        return (
            <MUITypography variant="h6" color="textPrimary">
                Search
            </MUITypography>
        );
    }

    // Reusable function to perform the API call
    performOmniSearch = () => {
        let { searchQuery } = this.state;

        if (/^\d+$/.test(searchQuery)) {
            searchQuery = searchQuery.slice(0, 10);
        }

        this.setState({ loading: true });

        api.send("POST", "/search/omniSearch", { omniSearchTerm: searchQuery })
            .then((response) => {
                if (response && response.orders && response.orders.length > 0) {
                    return this.setState({
                        orderFound: true,
                        order: response.orders[0],
                    })
                } else {
                    let updatedRows = response.patients.map((row) => {
                        const address = row.address ? row.address : "";
                        const cityStateZip = [
                            row.city ? row.city : null,
                            row.state ? row.state : null,
                            row.zip_code ? row.zip_code : null,
                        ]
                            .filter((part) => part !== null)
                            .join(", ");


                        const isPediatric = (dateOfBirth) => {
                            const age = moment().diff(dateOfBirth, 'years');
                            return age < 18;
                        };

                        return {
                            ...row,
                            date_of_birth: row.dateOfBirth ? moment(row.dateOfBirth).format("M/D/YYYY") : null,
                            patient: `${row.firstName} ${row.lastName}`,
                            isPediatric: isPediatric(row.dateOfBirth),
                            address: address,
                            city_state_zip: cityStateZip,
                            phone: row.phone ? row.phone
                                .replace(/\D/g, '')
                                .slice(0, 10)
                                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                                : null,
                        };
                    });

                    updatedRows.sort((a, b) => {
                        const firstNameComp = a.firstName.localeCompare(b.firstName, undefined, { sensitivity: 'base' });
                        if (firstNameComp !== 0) return firstNameComp;
                        return a.lastName.localeCompare(b.lastName, undefined, { sensitivity: 'base' });
                    });

                    this.setState({
                        rows: updatedRows,
                        loading: false,
                    });
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                this.setState({ loading: false });
            });
    };

    /**
     * Render main content text of dialog
     */
    renderContent() {
        const renderRedirect = () => {
            if (this.state.orderFound === true) {
                this.setState({ orderFound: false });
                this.props.onClose();
                return <Redirect to={{ pathname: "/chart/" + this.state.order.patientId + "/order/" + this.state.order.id }} />;
            }
        }
        return (
            <>
                <MUIGrid container spacing={1}>
                    <MUIGrid item xs>
                        <MUITextField
                            defaultValue={this.state.searchQuery}
                            autoFocus={true}
                            placeholder="Type to search..."
                            hiddenLabel={true}
                            fullWidth={true}
                            variant="filled"
                            size="small"
                            sx={{
                                marginBottom: 2,
                                "& .MuiInputLabel-root": { display: "none", height: 0 }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <MUIInputAdornment position="start">
                                        <MUISearchIcon />
                                    </MUIInputAdornment>
                                ),
                                disableUnderline: true,
                                style: { borderRadius: 4 }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    this.performOmniSearch();
                                }
                            }}
                            onChange={(e) => this.setState({ searchQuery: e.target.value })} // Update search query
                        />
                    </MUIGrid>
                    <MUIGrid item xs="auto">
                        <MUILoadingButton
                            variant="contained"
                            color="primary"
                            onClick={() => this.performOmniSearch()}
                            loading={this.state.loading}
                        >
                            Search
                        </MUILoadingButton>
                    </MUIGrid>
                    <MUIGrid item xs="auto">
                        <MUITooltip
                            title={
                                <>
                                    <div style={{width: 150}}>Search by:</div>
                                    <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
                                        <li>
                                            Order #
                                        </li>
                                        <li>
                                            Patient Name
                                            <ul style={{paddingLeft: '1.7em'}}>
                                                <li>"John Doe"</li>
                                                <li>"Doe, John"</li>
                                                <li>"Doe, J"</li>
                                            </ul>
                                        </li>
                                        <li>
                                            Date of Birth
                                            <ul style={{paddingLeft: '1.7em'}}>
                                                <li>01/01/1990</li>
                                                <li>1/1/1990</li>
                                                <li>1990-01-01</li>
                                            </ul>
                                        </li>
                                        <li>
                                            Phone Number
                                            <ul style={{paddingLeft: '1.7em'}}>
                                                <li>1234567890</li>
                                                <li>123-456-7890</li>
                                                <li>123 456 7890</li>
                                                <li>(123) 456-7890</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </>
                            }
                            arrow
                            placement="bottom"
                        >
                            <MUIIconButton size="small" sx={{ mt: .5 }}>
                                <MUIHelpOutlineIcon fontSize="small" />
                            </MUIIconButton>
                        </MUITooltip>
                    </MUIGrid>
                    <MUIGrid item xs="auto">
                        <Menu
                            menuItems={[
                                <MUIMenuItem key="create-patient"
                                    onClick={() => {
                                        this.props.history.push({
                                            pathname: "/patient/create/"
                                        });
                                        this.props.onClose();
                                    }}
                                >
                                    <MUIListItemIcon>
                                        <MUIPersonAddIcon fontSize="small" />
                                    </MUIListItemIcon>
                                    Create Patient
                                </MUIMenuItem>,
                                <MUIMenuItem
                                    key="advanced-search"
                                    onClick={() => {
                                        this.props.history.push({
                                            pathname: "/patient/search/"
                                        });
                                        this.props.onClose();
                                    }}
                                >
                                    <MUIListItemIcon>
                                        <MUIArrowForwardIcon fontSize="small" />
                                    </MUIListItemIcon>
                                    Advanced Search
                                </MUIMenuItem>,
                            ]}
                        />
                    </MUIGrid>
                </MUIGrid>
                {this.state.loading ? (
                    <MUIBox sx={{ height: 450, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Progress
                            loading={this.state.loading}
                            message={"Loading..."}
                        />
                    </MUIBox>
                ) : (
                    !this.state.rows || this.state.rows.length === 0 ? (
                        <MUIBox sx={{ height: 450, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <EmptyState
                                line1="No results found"
                                line2="Try searching for something a little different."
                            />
                        </MUIBox>
                    ) : (
                        <MUITableContainer
                            component={MUIPaper}
                            sx={(theme) => ({
                                height: 450,
                                overflow: "auto",
                                ...buildScrollbarSxOverrides(theme),
                            })}
                        >
                            <MUITable stickyHeader size="small">
                                <MUITableHead>
                                    <MUITableRow>
                                        <MUITableCell>Patient Name</MUITableCell>
                                        <MUITableCell></MUITableCell>
                                        <MUITableCell>DOB</MUITableCell>
                                        <MUITableCell>Phone #</MUITableCell>
                                        <MUITableCell>Address</MUITableCell>
                                        <MUITableCell></MUITableCell>
                                    </MUITableRow>
                                </MUITableHead>
                                <MUITableBody>
                                    {this.state.rows.map((row) => (
                                        <MUITableRow
                                            key={row.id}
                                            hover
                                            sx={{
                                                '&:last-child td, &:last-child th': { border: 0 },
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                this.props.history.push(`/chart/${row.id}`);
                                                this.props.onClose();
                                            }}>
                                            <MUITableCell component="th" scope="row" style={{ width: '200px' }}>{row.patient}</MUITableCell>
                                            <MUITableCell component="th" scope="row" style={{ width: '80px' }}>
                                                {row.isPediatric ? <MUIChildCareIcon fontSize="small" sx={{ color: MUIBlueColor[500] }} /> : null}
                                            </MUITableCell>
                                            <MUITableCell>{row.date_of_birth}</MUITableCell>
                                            <MUITableCell>{row.phone}</MUITableCell>
                                            <MUITableCell>
                                                <div>{row.address}</div>
                                                <div>{row.city_state_zip}</div>
                                            </MUITableCell>
                                            <MUITableCell>
                                                <MUIIconButton color="primary" variant="text" size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        window.open(`/chart/${row.id}`, "_blank");
                                                    }}>
                                                    <MUIOpenInNew />
                                                </MUIIconButton>
                                            </MUITableCell>
                                        </MUITableRow>
                                    ))}
                                </MUITableBody>
                            </MUITable>
                        </MUITableContainer>
                    )
                )}
                {renderRedirect()}
            </>
        );
    }

    /**
     * @returns {string} The max width of the dialog.
     */
    getMaxWidth() {
        return "lg";
    }
}
